import React from 'react';

const Media: React.FC = () => {
    return (
        <div style={{ padding: "2rem", maxWidth: 850, margin: "0 auto" }}>
            <h2 style={{ color: "#1976d2", fontSize: "2.2rem" }}>Media</h2>
            <section style={{ margin: "2rem 0" }}>
                <p>
                    Explore the latest updates, press releases, and media mentions about Algebracorp and our products.
                </p>
                <ul style={{ marginTop: "1rem", fontSize: "1.1rem" }}>
                    <li><strong>November 2025</strong>: Conveyr Phase I modules go live on app stores</li>
                    <li><strong>October 2025</strong>: Algebracorp announces partnership with URBANGRO retail</li>
                    <li><strong>August 2025</strong>: Algebracorp featured in Fintech Leaders magazine</li>
                    <li><strong>July 2025</strong>: TradeFlux market analysis platform beta release</li>
                </ul>
                <div style={{ marginTop: "2rem" }}>
                    <p>For media inquiries, interviews, or event invitations, email <a href="mailto:media@algebracorp.com">media@algebracorp.com</a></p>
                </div>
            </section>
        </div>
    );
};

export default Media;
